export const AUTH_ERRORS = {
  MULTI_FACTOR_REQUIRED: "auth/multi-factor-auth-required",
  INVALID_VERIFICATION_CODE: "auth/invalid-verification-code",
  INVALID_CREDENTIALS: "auth/invalid-credential",
  EMAIL_ALREADY_IN_USE: "auth/email-already-in-use",
  USER_NOT_FOUND: "auth/user-not-found",
  WRONG_PASSWORD: "auth/wrong-password",
  EMAIL_NOT_VERIFIED: "email-not-verified",
};
